interface OptionProps {
  label: string;
  stars: number;
  onStarsChange?: (stars: number) => void;
}

const FeedbackOption = (props: OptionProps) => {
  return (
    <svg
      width={312}
      height={106}
      viewBox="0 0 312 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <rect width={312} height={54} rx={11} fill="#8065C9" />
        <text
          fontSize={"16px"}
          y="24%"
          x="50%"
          fontFamily="Poppins"
          textAnchor="middle"
          fontWeight={600}
          fill="#fff"
        >
          {props?.label}
        </text>
      </g>

      <rect
        x={1}
        y={35}
        width={310}
        height={70}
        rx={10}
        fill="#fff"
        stroke="#8065C9"
        strokeWidth={2}
      />
      <g transform="translate(0,35)">
        <path
          onClick={() => {
            if (props.onStarsChange) props.onStarsChange(1);
          }}
          d="M47.2728 15L55.0252 25.6026L67.5045 29.6992L59.8165 40.3485L59.7767 53.4829L47.2728 49.462L34.769 53.4829L34.7292 40.3485L27.0412 29.6992L39.5205 25.6026L47.2728 15Z"
          fill={props?.stars >= 1 ? "#8065C9" : "#D3D3D3"}
        />
        <path
          onClick={() => {
            if (props.onStarsChange) props.onStarsChange(2);
          }}
          d="M102.002 15L109.586 25.6026L121.794 29.6992L114.273 40.3485L114.234 53.4829L102.002 49.462L89.7698 53.4829L89.7308 40.3485L82.2099 29.6992L94.4179 25.6026L102.002 15Z"
          fill={props?.stars >= 2 ? "#8065C9" : "#D3D3D3"}
        />
        <path
          onClick={() => {
            if (props.onStarsChange) props.onStarsChange(3);
          }}
          d="M156.506 15L164.175 25.6026L176.518 29.6992L168.914 40.3485L168.874 53.4829L156.506 49.462L144.139 53.4829L144.099 40.3485L136.495 29.6992L148.838 25.6026L156.506 15Z"
          fill={props?.stars >= 3 ? "#8065C9" : "#D3D3D3"}
        />
        <path
          onClick={() => {
            if (props.onStarsChange) props.onStarsChange(4);
          }}
          d="M210.774 15L218.274 25.6026L230.346 29.6992L222.909 40.3485L222.871 53.4829L210.774 49.462L198.678 53.4829L198.64 40.3485L191.203 29.6992L203.275 25.6026L210.774 15Z"
          fill={props?.stars >= 4 ? "#8065C9" : "#D3D3D3"}
        />
        <path
          onClick={() => {
            if (props.onStarsChange) props.onStarsChange(5);
          }}
          d="M265.273 15L273.025 25.6026L285.505 29.6992L277.816 40.3485L277.777 53.4829L265.273 49.462L252.769 53.4829L252.729 40.3485L245.041 29.6992L257.52 25.6026L265.273 15Z"
          fill={props?.stars >= 5 ? "#8065C9" : "#D3D3D3"}
        />
      </g>
    </svg>
  );
};

export default FeedbackOption;
